<script>
import ListBase from '../../../components/ListBase';

export const importadorHeaders = [
        {text: 'Nombre', value: 'nombre'},
    {text: 'Dirección', value: 'direccion'},
    {text: 'País', value: 'nombrePais'},
    {text: 'Ciudad', value: 'ciudad'},
    {text: 'Código Postal', value: 'codigoPostal'},
    {text: 'Email', value: 'email'},
];

    export default {
  name: 'ListaPersonaBase',
  extends: ListBase,
  data: () => ({
    headers: importadorHeaders,
    title: 'Importadores',
    baseApi: 'importador',
  }),
  methods: {
    onItemClick(item) {
      this.$router.push({ path: item.idImportador.toString(), append: true }).catch(err => {});
    },
  },
  computed: {
    canCreate() {
      return true;
    },
  },
};
</script>

<style scoped>

</style>
